import React, { useEffect } from 'react';
import LogoSrc from '../assets/images/LingoPass.svg';
import '../styles/main.css';
import { Logo, PageWrapper } from '../styles/styledComponents';

export default function Layout({ children }) {
  useEffect(() => {
    fetch(`/get-session-data`)
      .then((response) => response.json())
      .then((resultData) => {
        window.gtag('set', { campaignName: resultData.utm_campaign });
        window.gtag('set', { campaignSource: resultData.utm_source });
        window.gtag('set', { campaignMedium: resultData.utm_medium });
        window.gtag('set', { campaignContent: resultData.utm_content });
        window.gtag('set', { campaignTerm: resultData.utm_term });
      });
  }, []);

  return (
    <PageWrapper>
      <Logo src={LogoSrc} />
      {children}
    </PageWrapper>
  );
}
